import { useEffect, useRef } from 'react';

const useDidMountEffect = (func: () => void, dependency: readonly any[]) => {
  const didMount = useRef(false);

  useEffect(() => {
    if (didMount.current) func();
    else {
      didMount.current = true;
    }
  }, dependency);
};

export default useDidMountEffect;
